import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";

const DraftTutorsSalaryView = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();

  const getListDataLevel = async () => {
    setIsLoading(true);

    await levelModal
      .list()
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (parmas.mid != "") {
      getListDataLevel();
    }
  }, []);

  console.log(dataList, "dataListlevel");
  // const du = new DeviceUUID();
  // const uuid = du.get();
  const handleDownload = (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);

  const [ListLevel, setListLevel] = useState();
  const [levelId, setLevelId] = useState("");
  const getListBylevelId = async () => {
    // setLevelId(id);
    setIsLoading(true);
    await levelModal
      .listbyLevelid(levelId)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setListLevel(result?.data?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    if (levelId !== "") {
      getListBylevelId();
    }
  }, [levelId]);

  const [selectuser, setSelectdUser] = useState("");
  const interViewUser = (id) => {
    setSelectdUser(id);
  };
  console.log(selectuser, "selectuser");

  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");
  const [priceStart, setPriceStart] = useState(""); // State to store start time
  const [priceUpto, setPriceUpTO] = useState(""); // State to store end time
  const [name, setName] = useState();

  // Function to handle changes in the start time input
  const handlepriceStart = (event) => {
    const { value } = event.target;
    setPriceStart(value); // Update startTime state with the selected time
  };

  // Function to handle changes in the end time input
  const handlePriceUpto = (event) => {
    const { value } = event.target;
    setPriceUpTO(value); // Update endTime state with the selected time
  };

  const handleName = (event) => {
    const { value } = event.target;
    setName(value); // Update endTime state with the selected time
  };

  const [inputsAbout, setInputsAbout] = useState([{ id: 1, value: "" }]);

  const handleInputChangeAbout = (index, event) => {
    const values = [...inputsAbout];
    values[index].value = event.target.value;
    setInputsAbout(values);
  };
  const inputsProvalues = inputsAbout && inputsAbout?.map((item) => item.value);
  const handleAddInputAbout = () => {
    const newInputs = [
      ...inputsAbout,
      { id: inputsAbout.length + 1, value: "" },
    ];
    setInputsAbout(newInputs);
  };
  const handleRemoveInputAbout = (index) => {
    if (inputsAbout?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsAbout];
    values.splice(index, 1);
    setInputsAbout(values);
  };

  const clearState = () => {
    setPriceStart("");
    setPriceUpTO("");
    setName("");
    setInputsAbout("");
  };

  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      name: name,
      price_start: parseInt(priceStart),
      price_upto: parseInt(priceUpto),
      about: inputsProvalues,
    };
    levelModal
      .createLelvel(data)
      .then((response) => {
        clearState();
        getListDataLevel();
        helper.sweetalert.toast(response.message, "success");
        toggle();
        setAddsLoadig(false);
      })
      .catch((error) => {
        setAddsLoadig(false);
      });
  };

  const [formData, setFormData] = useState({
    name: "",
    price_start: "",
    price_upto: "",
  });

  useEffect(() => {
    // Set default values when the component mounts
    if (ListLevel) {
      setFormData({
        name: ListLevel?.name || "",
        price_start: ListLevel.price_start || "",
        price_upto: ListLevel.price_upto || "",
      });
    }
  }, [ListLevel]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [inputseditDesc, setInputseditDess] = useState([]);

  useEffect(() => {
    if (ListLevel && ListLevel.about) {
      setInputseditDess(
        ListLevel.about.map((value, index) => ({
          id: index,
          value: value || "",
        }))
      );
    }
  }, [ListLevel]);

  // Function to handle changes in the edit description input fields
  const handleInputChangeeditDesc = (index, event) => {
    const values = [...inputseditDesc];
    values[index].value = event.target.value;
    setInputseditDess(values);
  };

  // Function to handle adding a new edit description input field
  const handleAddInputeditDesc = () => {
    const newInputs = [
      ...inputseditDesc,
      { id: inputseditDesc.length, value: "" },
    ];
    setInputseditDess(newInputs);
  };

  // Function to handle removing an edit description input field
  const handleRemoveInputeditDesc = (index) => {
    if (inputseditDesc.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputseditDesc];
    values.splice(index, 1);
    setInputseditDess(values);
  };
  const inputsProvalueseditDesc =
    inputseditDesc && inputseditDesc?.map((item) => item.value);

  const handleSubmitEditLevel = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      id: levelId,
      name: formData.name,
      price_start: parseInt(formData.price_start),
      price_upto: parseInt(formData.price_upto),
      about: inputsProvalueseditDesc,
    };

    levelModal
      .editLevel(data)
      .then((response) => {
        getListDataLevel();
        helper.sweetalert.toast(response.message, "success");
        setFormData("");
        toggle1();
        setAddsLoadig(false);
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data.message, "error");
        console.log(error, "error");
        setAddsLoadig(false);
        setFormData("");
      });
  };

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          levelModal.removeLevel(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListDataLevel();
          });
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  console.log(formData, "formData");
  console.log(ListLevel, "ListLevelId");

  return (
    <Container className="pt-7">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between ">
              <div className="d-flex flex-row">
                {/* <p style={{fontWeight:"bold",marginRight:"10px"}} >Filters </p> */}
                <p style={{ fontWeight: "bold", marginRight: "10px" }}>
                  Payment Orader For Saurabh Singh{" "}
                </p>
              </div>

              <div className="d-flex flex-row">
                <p style={{ fontWeight: "bold", marginRight: "10px" }}>
                  Filters{" "}
                </p>
                <Input
                  className="mr-4"
                  type="date"
                  placeholder="Search"
                  size="sm"
                />
                {/* <i class="fa-solid fa-magnifying-glass"></i> */}

                <Input
                  className="mr-4"
                  type="text"
                  placeholder="Search"
                  size="sm"
                />

                <Button
                  size="sm"
                  // onClick={toggle}
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    border: "none",
                    width: "150px",
                    height: "30px",
                  }}
                >
                  Clear
                </Button>

                <Button
                  size="sm"
                  onClick={toggle}
                  style={{
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    width: "150px",
                    height: "30px",
                  }}
                >
                  +Add
                </Button>
              </div>
            </CardHeader>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">#</th>
                  {/* <th scope="col">CLASS ID</th> */}
                  <th scope="col">Invoice id</th>
                  <th scope="col"> Class </th>
                  <th scope="col">Cycle </th>
                  <th scope="col">Type</th>
                  <th scope="col">Amount </th>
                  <th scope="col">Due  </th>
                  <th scope="col">Receipt </th>
                  <th scope="col"> File </th>
                  
                  <th scope="col">unites</th>
                  

                  <th scope="col"> Rate</th>
                  
                  <th scope="col">Note</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              {/* {!isLoading && (
                    <tbody>
                      {dataList?.data?.length > 0 ? (
                        dataList?.data?.map((item, index) => {
                          return (
                            <tr key={item._id} style={{ cursor: "pointer" }}>
                              <td>{((currentPage-1) * perPage) + index + 1}</td>

                              <td>{item?.name || "-"} </td>
                              <td>{item?.parent || "-"}</td>
                              <td>{item?.tutor || "-"}</td>
                              <td>{item?.price_tutor || "-"}</td>
                              <td>{item?.price_parent || "-"}</td>
                              <td>{item?.status || "-"}</td>
                              <td>{item?.mode || "-"}</td>
                              <td>{item?.type || "-"}</td>

                              <td
                                className="p-0"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // justifyContent: "center",
                                  // alignItems: "center",
                                }}
                              >
                                <UncontrolledTooltip
                                  placement="top"
                                  target="eyeTooltip"
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="eyeTooltip"
                                  to={`/admin/classes/editclasss/${item?.id}`}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link>

                                

                                <UncontrolledTooltip
                                  placement="top"
                                  target="studentlist"
                                >
                                  Student List
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="studentlist"
                                  to={`/admin/studentlist`}
                                >
                                  <i class="fa-solid fa-list"></i>
                                </Link>

                                <UncontrolledTooltip
                                  placement="top"
                                  target="Attendenc"
                                >
                                  Attendence
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="Attendenc"
                                  to={`/admin/attendance`}
                                >
                                  <i class="fa-solid fa-clipboard-user"></i>
                                </Link>
                                <UncontrolledTooltip
                                  placement="top"
                                  target="userTooltip"
                                >
                                  Delete
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "red",
                                    marginTop: "10px",
                                    // backgroundColor: "#f5f5f5",
                                    display: "inline-block",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "20%", // Optional: Make it a circle
                                  }}
                                  id="userTooltip"
                                  onClick={() => handleDel(item.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </p>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="6" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )} */}
              <tbody>
                <tr>
                  <td>
                    1
                  </td>
                  <td>2352754</td>
                  <td>Class 1</td>
                  <td>Cycle 2</td>
                  <td>Cash </td>
                  <td>1000</td>
                  <td> 800</td>
                  <td>1000 </td>
                  <td>- </td>
                  <td>Rs 200</td>
                  <td>200</td>
                  <td>Note</td>

                  <td
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <UncontrolledTooltip placement="top" target="eyeTooltip">
                      View
                    </UncontrolledTooltip>
                    <Link
                      style={{
                        margin: "0 5px",
                        fontSize: "15px",
                        color: "blue",
                        // backgroundColor: "#f5f5f5",
                        alignItems: "center",
                        display: "inline-block",
                        marginTop: "10px",
                        // padding: "5px", // Optional: Add padding for better appearance
                        borderRadius: "30%", // Optional: Make it a circle
                      }}
                      id="eyeTooltip"
                      to={`/admin/draftPaymentOrader`}
                      // tag={Link}
                    >
                      <i class="fa-solid fa-eye"></i>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>
                    2
                  </td>
                  <td>9052754</td>
                  <td>Class 3</td>
                  <td>Cycle 4</td>
                  <td>Cash </td>
                  <td>1000</td>
                  <td> 800</td>
                  <td>1000 </td>
                  <td>- </td>
                  <td>Rs 200</td>
                  <td>200</td>
                  <td>Note</td>

                  <td
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <UncontrolledTooltip placement="top" target="eyeTooltip">
                      View
                    </UncontrolledTooltip>
                    <Link
                      style={{
                        margin: "0 5px",
                        fontSize: "15px",
                        color: "blue",
                        // backgroundColor: "#f5f5f5",
                        alignItems: "center",
                        display: "inline-block",
                        marginTop: "10px",
                        // padding: "5px", // Optional: Add padding for better appearance
                        borderRadius: "30%", // Optional: Make it a circle
                      }}
                      id="eyeTooltip"
                      to={`/admin/draftPaymentOrader`}
                      // tag={Link}
                    >
                      <i class="fa-solid fa-eye"></i>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>
                    3
                  </td>
                  <td>09754</td>
                  <td>Class 9</td>
                  <td>Cycle 2</td>
                  <td>Cash </td>
                  <td>1000</td>
                  <td> 800</td>
                  <td>1000 </td>
                  <td>- </td>
                  <td>Rs 200</td>
                  <td>200</td>

                  <td>Note</td>
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <UncontrolledTooltip placement="top" target="eyeTooltip">
                      View
                    </UncontrolledTooltip>
                    <Link
                      style={{
                        margin: "0 5px",
                        fontSize: "15px",
                        color: "blue",
                        // backgroundColor: "#f5f5f5",
                        alignItems: "center",
                        display: "inline-block",
                        marginTop: "10px",
                        // padding: "5px", // Optional: Add padding for better appearance
                        borderRadius: "30%", // Optional: Make it a circle
                      }}
                      id="eyeTooltip"
                      to={`/admin/draftPaymentOrader`}
                      // tag={Link}
                    >
                      <i class="fa-solid fa-eye"></i>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>
4
                  </td>
                  <td>564</td>
                  <td>Class 1</td>
                  <td>Cycle 2</td>
                  <td>Cash </td>
                  <td>1000</td>
                  <td> 800</td>
                  <td>1000 </td>
                  <td>- </td>
                  <td>Rs 200</td>
                  <td>200</td>
                  <td>Note</td>

                  <td
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <UncontrolledTooltip placement="top" target="eyeTooltip">
                      View
                    </UncontrolledTooltip>
                    <Link
                      style={{
                        margin: "0 5px",
                        fontSize: "15px",
                        color: "blue",
                        // backgroundColor: "#f5f5f5",
                        alignItems: "center",
                        display: "inline-block",
                        marginTop: "10px",
                        // padding: "5px", // Optional: Add padding for better appearance
                        borderRadius: "30%", // Optional: Make it a circle
                      }}
                      id="eyeTooltip"
                      to={`/admin/draftPaymentOrader`}
                      // tag={Link}
                    >
                      <i class="fa-solid fa-eye"></i>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
        </div>
      </Row>

      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <h4>Tutor Receipt</h4>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Invoice id</Label>
                  <Input
                    id="forType"
                    type="text"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter Invoice id "
                    defaultValue={"232334"}
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Class</Label>
                  <Input id="forType" name="forType" type="select">
                    <option value="driver">Select Class </option>
                    <option value="tutor"> Class 1</option>
                    <option value="student">Class 2</option>
                    <option value="student">Class 3</option>
                    <option value="student">Class 4</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Cycle</Label>
                  <Input id="forType" name="forType" type="select">
                    <option value="driver">Select Cycle</option>
                    <option value="tutor">Cycle 1</option>
                    <option value="student">Cycle 2</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Transaction Type</Label>
                  <Input id="forType" name="forType" type="select">
                    <option value="driver">Select Cycle</option>
                    <option value="tutor"> online</option>
                    <option value="student"> Cash</option>
                    <option value="tutor"> Check</option>
                    <option value="student"> Bank Transfer</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail"> Total Amount</Label>
                  <Input
                    id="forType"
                    type="text"
                    // onChange={handleName}
                    // value={name}
                    defaultValue={"1000"}
                    disabled
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail"> Due Amount</Label>
                  <Input
                    id="forType"
                    type="text"
                    // onChange={handleName}
                    // value={name}
                    disabled
                    defaultValue={"800"}
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail"> Receipt Amount</Label>
                  <Input
                    id="forType"
                    type="text"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Upload Receipt</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="forType"
                    type="file"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter UPI id "
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Note</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="forType"
                    type="textarea"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter Note"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
          </Form>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
            {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
            <Button
              type="submit"
              style={{
                float: "right",
                marginLeft: "5%",
                backgroundColor: "#080278",
                color: "white",
                border: "none",
              }}
              onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default DraftTutorsSalaryView;
